(function () {
  const SEL = '.wishlist-engine.aldo-wishlist-heart';
  const optimisticWishlist = new WeakMap();

  function getWishlistControl(root) {
    if (!root) return null;
    const withAria =
      root.querySelector(
        'button[aria-pressed], a[aria-pressed], [role="button"][aria-pressed], .wishlist-engine-button[aria-pressed], [aria-pressed][class*="wishlist"]'
      ) || root.querySelector('[aria-pressed]');
    if (withAria) return withAria;
    const engineBtn = root.querySelector('.wishlist-engine-button, [class*="wishlist-engine-button"]');
    if (engineBtn) return engineBtn;
    return root.querySelector('button, a, [role="button"]');
  }

  function detectFilledBlackHeartSvg(root) {
    const path = root.querySelector('.wishlist-engine-button svg path, .wishlist-icon svg path, svg path');
    if (!path) return false;
    const f = (path.getAttribute('fill') || '').toLowerCase().replace(/\s/g, '');
    const st = (path.getAttribute('stroke') || '').toLowerCase().replace(/\s/g, '');
    const isBlack = (v) => v === '#000000' || v === '#000' || v === 'black' || v === 'rgb(0,0,0)';
    return f && f !== 'none' && f !== 'transparent' && isBlack(f) && st && st !== 'none' && isBlack(st);
  }

  function isActiveRoot(root) {
    if (!root || root.nodeType !== 1) return false;
    const rc = root.getAttribute('class') || '';
    if (/\b(wishlisted|in-wishlist|is-saved|wished|filled|se-wishlist|wishlist-saved|wishlist-added)\b/i.test(rc))
      return true;
    for (let i = 0; i < root.attributes.length; i++) {
      const a = root.attributes[i];
      const name = (a.name || '').toLowerCase();
      const val = (a.value || '').trim().toLowerCase();
      if (!val || val === 'false' || val === '0') continue;
      if (/data-(in-wishlist|wishlisted|in_wishlist)/.test(name)) return true;
      if (/data-(wishlist[-_]?saved|wishlist[-_]?added)/.test(name)) return true;
      if (/wishlisted|saved|wished|in_wishlist|in-wishlist/.test(name) && !/^data-product/.test(name)) return true;
    }
    return false;
  }

  function detectInWishlist(root, btn) {
    if (!btn) return isActiveRoot(root);
    let ap = btn.getAttribute('aria-pressed');
    if (ap == null || ap === '') ap = root.getAttribute('aria-pressed');
    if (ap === 'false') return false;
    if (ap === 'true') return true;
    let ac = btn.getAttribute('aria-checked');
    if (ac == null || ac === '') ac = root.getAttribute('aria-checked');
    if (ac === 'false') return false;
    if (ac === 'true') return true;

    if (isActiveRoot(root)) return true;

    const cls = btn.className;
    if (typeof cls === 'string' && cls.length) {
      if (
        /wishlist[-_]?added|in[-_]?wishlist|is[-_]?saved|wished|wishlisted|heart[-_]?fill|se-wishlist|wishlist[-_]?saved|se-wishlist--active|se-wishlist--saved|\bis-active\b|\bbtn-active\b/i.test(
          cls
        )
      ) {
        return true;
      }
    }
    const label = (btn.getAttribute('aria-label') || '').toLowerCase();
    if (
      label &&
      /remove from wishlist|remove.*wishlist|in your wishlist|from your wishlist|added to (your )?wishlist/i.test(label)
    )
      return true;

    if (detectFilledBlackHeartSvg(root)) return true;

    return false;
  }

  function syncActiveClass(root) {
    const btn = getWishlistControl(root);
    const detected = detectInWishlist(root, btn);
    const opt = optimisticWishlist.get(root);
    const now = Date.now();

    if (opt && now < opt.until) {
      if (opt.mode === 'add') {
        root.classList.add('aldo-wishlist-active');
        if (detected) optimisticWishlist.delete(root);
      } else {
        root.classList.remove('aldo-wishlist-active');
        if (!detected) optimisticWishlist.delete(root);
      }
      return;
    }
    if (opt) optimisticWishlist.delete(root);
    root.classList.toggle('aldo-wishlist-active', detected);
  }

  function syncWishlistVariant(variantId) {
    if (variantId == null) return;
    document.querySelectorAll('.wishlist-engine[data-product_id]').forEach((el) => {
      el.setAttribute('data-variant_id', String(variantId));
    });
  }

  function watchRoot(root) {
    if (!root || root.dataset.aldoWishlistObserved) return;
    root.dataset.aldoWishlistObserved = 'true';
    syncActiveClass(root);
    let t = null;
    const debouncedSync = () => {
      clearTimeout(t);
      t = setTimeout(() => syncActiveClass(root), 45);
    };
    const mo = new MutationObserver(debouncedSync);
    mo.observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
    });
  }

  function discover() {
    document.querySelectorAll(SEL).forEach(watchRoot);
  }

  function resyncAllSoon() {
    [0, 10, 30, 60, 100, 200, 350, 600, 1000, 1800].forEach((ms) => {
      setTimeout(() => {
        document.querySelectorAll(SEL).forEach(syncActiveClass);
      }, ms);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    discover();
    resyncAllSoon();

    document.addEventListener(
      'pointerdown',
      (e) => {
        const root = e.target.closest?.(SEL);
        if (!root) return;
        const btn = getWishlistControl(root);
        if (!btn) return;
        const pressed =
          btn.getAttribute('aria-pressed') === 'true' ||
          root.getAttribute('aria-pressed') === 'true' ||
          detectFilledBlackHeartSvg(root);
        if (pressed) {
          root.classList.remove('aldo-wishlist-active');
          optimisticWishlist.set(root, { until: Date.now() + 1500, mode: 'remove' });
        } else {
          root.classList.add('aldo-wishlist-active');
          optimisticWishlist.set(root, { until: Date.now() + 4500, mode: 'add' });
        }
        requestAnimationFrame(() => {
          syncActiveClass(root);
          requestAnimationFrame(() => syncActiveClass(root));
        });
      },
      true
    );

    document.addEventListener(
      'click',
      (e) => {
        if (e.target.closest?.(SEL)) resyncAllSoon();
      },
      true
    );

    const docMo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches?.(SEL)) watchRoot(node);
          node.querySelectorAll?.(SEL).forEach(watchRoot);
        });
      }
    });
    docMo.observe(document.body, { childList: true, subtree: true });

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const variant = event?.data?.variant;
        if (variant?.id != null) syncWishlistVariant(variant.id);
        requestAnimationFrame(() => {
          document.querySelectorAll('.product-media-container ' + SEL).forEach(syncActiveClass);
        });
      });
    }
  });
})();
